<template>
  <div class="pcSetting">
    <el-button
      type="primary"
      size="small"
      style="position: absolute; right: 80px; top: 20px"
      @click="updataSchoolPage"
      >更新</el-button
    >
    <el-button
      type="primary"
      size="small"
      style="position: absolute; right: 10px; top: 20px"
      @click="saveSchoolPage"
      >保存</el-button
    >

    <el-select
      v-model="mainUrl"
      style="position: absolute; width: 150px; right: 250px; top: 20px"
      placeholder="请选择"
      size="mini"
      @change="getSchoolPageMenuListByUrl(mainUrl)"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>

    <div class="pcSettingMain">
      <div class="pcLeft">
        <div class="pcLeftItem" @click="addModule(1, '轮播图')">
          <div style="font-size: 30px" class="iconfont icon-lunbotu"></div>
          <div style="font-size: 13px">轮播图</div>
        </div>
        <div class="pcLeftItem" @click="addModule(4, '广告')">
          <div
            style="font-size: 30px"
            class="iconfont icon-shangpinkecheng"
          ></div>
          <div style="font-size: 13px">广告</div>
        </div>
        <div class="pcLeftItem" @click="addModule(2, '模板')">
          <div
            style="font-size: 30px"
            class="iconfont icon-shangpinkecheng"
          ></div>
          <div style="font-size: 13px">模板</div>
        </div>
        <div class="pcLeftItem" @click="addModule(5, '悬浮窗')">
          <div
            style="font-size: 30px"
            class="iconfont icon-shangpinkecheng"
          ></div>
          <div style="font-size: 13px">悬浮窗</div>
        </div>
        <div class="pcLeftItem" @click="addModule(3, '自定义')">
          <div
            style="font-size: 30px"
            class="iconfont icon-shangpinkecheng"
          ></div>
          <div style="font-size: 13px">自定义</div>
        </div>
      </div>

      <div class="pcCenter">
        <div class="pageContainer" id="pcCenterMain">
          <draggable
            v-model="homePageList"
            @update="datadragEndContent"
            :options="{ animation: 500 }"
          >
            <div
              v-for="(pageItem, pageIndex) in homePageList"
              :key="pageItem.id"
            >
              <div
                :class="
                  pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                "
                @mouseenter="hoverModule(pageIndex)"
                @mouseleave="leaveModule(pageIndex)"
                @click="activeModule(pageIndex)"
                v-if="pageItem.type == 1"
                :key="pageItem.id"
              >
                <div
                  class="iconfont icon-shanchu"
                  v-if="pageItem.moduleHover"
                  @click="deleteModule(pageIndex)"
                ></div>
                <template
                  v-if="
                    pageItem.schoolPageItemList &&
                    pageItem.schoolPageItemList.length > 0
                  "
                >
                  <carousel
                    :list="pageItem.schoolPageItemList"
                    :editForm="pageItem.template"
                  ></carousel>
                </template>
                <template v-else>
                  <div class="emptyDiv">轮播图</div>
                </template>
              </div>
              <div
                class="mainContent"
                v-if="pageItem.type == 2"
                :key="pageItem.id"
              >
                <div
                  :class="
                    pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                  "
                  @mouseenter="hoverModule(pageIndex)"
                  @mouseleave="leaveModule(pageIndex)"
                  @click="activeModule(pageIndex)"
                >
                  <div
                    class="iconfont icon-shanchu"
                    v-if="pageItem.moduleHover"
                    @click="deleteModule(pageIndex)"
                  ></div>
                  <template
                    v-if="
                      pageItem.schoolPageItemList &&
                      pageItem.schoolPageItemList.length > 0
                    "
                  >
                    <div class="moudleTitle">
                      {{ pageItem.title
                      }}<span class="subTitle">{{ pageItem.subTitle }}</span>
                    </div>
                    <div
                      class="moudleGoodsMain"
                      :class="
                        pageItem.template &&
                        pageItem.template.objectType == '分页'
                          ? ''
                          : 'flex'
                      "
                    >
                      <div
                        v-for="(item, index) in pageItem.schoolPageItemList"
                        :key="item.id"
                        @mouseenter="hoverStart(pageIndex, index)"
                        @mouseleave="hoverEnd(pageIndex, index)"
                      >
                        <muban-template
                          :attributeObj="item"
                          :mubanWidth="pageItem.mubanWidth"
                          :dynamicObj="item.dynamicObj"
                        ></muban-template>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="emptyDiv">模板</div>
                  </template>
                </div>
              </div>
              <div
                :class="
                  pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                "
                @mouseenter="hoverModule(pageIndex)"
                @mouseleave="leaveModule(pageIndex)"
                @click="activeModule(pageIndex)"
                v-if="pageItem.type == 3"
                :key="pageItem.id"
              >
                <div
                  class="iconfont icon-shanchu"
                  v-if="pageItem.moduleHover"
                  @click="deleteModule(pageIndex)"
                ></div>
                <component
                  :is="pageItem.title"
                  v-if="pageItem.title"
                ></component>
                <div class="emptyDiv" v-else>自定义组件</div>
              </div>

              <div
                class="moduleMain"
                :class="[{ active: pageItem.moduleHover }]"
                :style="
                  pageItem.schoolPageItemList[0] &&
                  pageItem.schoolPageItemList[0].dynamicObj
                    ? pageItem.schoolPageItemList[0].dynamicObj.style
                    : ''
                "
                @mouseenter="hoverModule(pageIndex)"
                @mouseleave="leaveModule(pageIndex)"
                @click="activeModule(pageIndex)"
                v-if="pageItem.type == 5"
                :key="pageItem.id"
              >
                <div
                  class="iconfont icon-shanchu"
                  v-if="pageItem.moduleHover"
                  @click="deleteModule(pageIndex)"
                ></div>
                <template
                  v-if="
                    pageItem.schoolPageItemList &&
                    pageItem.schoolPageItemList.length > 0
                  "
                >
                  <div class="moudleGoodsMain">
                    <div
                      v-for="(item, index) in pageItem.schoolPageItemList"
                      :key="item.id"
                      @mouseenter="hoverStart(pageIndex, index)"
                      @mouseleave="hoverEnd(pageIndex, index)"
                    >
                      <muban-template
                        :attributeObj="item"
                        :mubanWidth="pageItem.mubanWidth"
                        :dynamicObj="item.dynamicObj"
                      ></muban-template>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="emptyDiv">悬浮窗</div>
                </template>
              </div>

              <!-- 广告 -->
              <div
                class="mainContent"
                v-if="pageItem.type == 4"
                :key="pageItem.id"
              >
                <div
                  :class="
                    pageItem.moduleHover ? 'moduleMain active' : 'moduleMain'
                  "
                  @mouseenter="hoverModule(pageIndex)"
                  @mouseleave="leaveModule(pageIndex)"
                  @click="activeModule(pageIndex)"
                >
                  <div
                    class="iconfont icon-shanchu"
                    v-if="pageItem.moduleHover"
                    @click="deleteModule(pageIndex)"
                  ></div>
                  <template
                    v-if="
                      pageItem.schoolPageItemList &&
                      pageItem.schoolPageItemList.length > 0
                    "
                  >
                    <div class="moudleTitle">{{ pageItem.title }}</div>
                    <div class="moudleGoodsMain flex">
                      <div
                        v-for="(item, index) in pageItem.schoolPageItemList"
                        :key="item.id"
                        @mouseenter="hoverStart(pageIndex, index)"
                        @mouseleave="hoverEnd(pageIndex, index)"
                      >
                        <muban-template
                          :attributeObj="{ schoolPageInfo: item }"
                          :mubanWidth="pageItem.mubanWidth"
                          :dynamicObj="item.dynamicObj"
                        ></muban-template>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="emptyDiv">广告</div>
                  </template>
                </div>
              </div>
              <!-- 广告 -->
            </div>
          </draggable>
        </div>
      </div>

      <div class="pcRight">
        <div class="operation">
          <div v-if="!activeType" class="operation-1">
            <div class="operation-1-text">请点击选中左侧模块区域进行编辑</div>
          </div>

          <div v-if="homePageList.length > 0">
            <div v-if="activeType == 1">
              <div class="operation-name">轮播图</div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">模板:</span>
                <el-select
                  v-model="homePageList[activeIndex].templateId"
                  placeholder="选择模板"
                  @change="changeLBTemplate"
                >
                  <el-option
                    v-for="item in templateOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="operation-1">
                <div class="operation-1-text">添加内容</div>
                <div class="operation-1-text1">
                  最多添加12个轮播图，拖动选中的轮播图可对其排序，建议尺寸750*260像素
                </div>
              </div>
              <div
                class="operation-2"
                v-if="
                  homePageList[activeIndex] &&
                  homePageList[activeIndex].schoolPageItemList
                "
              >
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="operation-2-list"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="item.id"
                  >
                    <div class="list-img">
                      <el-upload
                        class="crm-upload"
                        :action="fileObj.url"
                        :before-upload="lbtbeforeUpload"
                        :on-success="lbtSuccessUpdate"
                        :headers="reqData"
                        :show-file-list="false"
                      >
                        <img
                          class="list-img"
                          :src="item.picture"
                          @click="updateImg(index)"
                          alt
                        />
                        <div class="list-img-uptext" @click="updateImg(index)">
                          修改
                        </div>
                      </el-upload>
                    </div>
                    <div class="list-msg">
                      <div class="list-msg-item">
                        <span style="width: 50px">标题</span>
                        <el-input
                          size="mini"
                          style="width: 200px"
                          placeholder="选填"
                          v-model="item.title"
                          clearable
                        ></el-input>
                      </div>

                      <div class="list-msg-item">
                        <span style="width: 50px">链接</span>
                        <el-input
                          style="width: 140px"
                          @input="changeInput(index)"
                          size="mini"
                          v-if="item.type == 2"
                          v-model="item.title"
                          clearable
                        ></el-input>
                        <el-input
                          style="width: 140px"
                          size="mini"
                          @input="changeInput(index)"
                          v-else-if="item.linkUrl"
                          v-model="item.linkUrl"
                          clearable
                        ></el-input>
                        <el-dropdown trigger="click" @command="handleCommand">
                          <span
                            class="el-dropdown-link"
                            style="
                              color: rgb(77, 148, 255);
                              cursor: pointer;
                              margin-left: 10px;
                            "
                          >
                            {{
                              item.linkUrl || item.type == 2
                                ? "修改"
                                : "选择跳转到的页面"
                            }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="2 + '-' + index"
                              >模板</el-dropdown-item
                            >
                            <el-dropdown-item :command="4 + '-' + index"
                              >外部链接</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <i
                      class="el-icon-delete operation-delete"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                </draggable>
              </div>
              <div class="operation-2-button">
                <el-upload
                  style="width: 100%"
                  class="crm-upload"
                  :action="fileObj.url"
                  :before-upload="lbtbeforeUpload"
                  :on-success="lbtSuccess"
                  :headers="reqData"
                  multiple
                  :show-file-list="false"
                >
                  <el-button icon="el-icon-plus" style="width: 380px"
                    >添加轮播图</el-button
                  >
                </el-upload>
              </div>
            </div>

            <div v-if="activeType == 2">
              <div class="operation-name">模板</div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">标题:</span>
                <el-input
                  size="mini"
                  style="width: 200px"
                  placeholder="选填"
                  v-if="homePageList[activeIndex]"
                  v-model="homePageList[activeIndex].title"
                  clearable
                ></el-input>
              </div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">副标题:</span>
                <el-input
                  size="mini"
                  style="width: 200px"
                  placeholder="选填"
                  v-if="homePageList[activeIndex]"
                  v-model="homePageList[activeIndex].subTitle"
                  clearable
                ></el-input>
              </div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">更多:</span>
                <el-input
                  size="mini"
                  style="width: 200px"
                  placeholder="选填"
                  v-if="homePageList[activeIndex]"
                  v-model="homePageList[activeIndex].moreUrl"
                  clearable
                ></el-input>
              </div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">模板:</span>
                <el-select
                  v-model="homePageList[activeIndex].templateId"
                  placeholder="选择模板"
                  @change="changeTemplate"
                >
                  <el-option
                    @mouseover.native="previewTemp(item)"
                    @mouseleave.native="hidePreviewTemp(item)"
                    v-for="item in templateOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="label-show"
                style="margin-top: 20px"
                v-if="
                  this.homePageList[this.activeIndex].template &&
                  this.homePageList[this.activeIndex].template.objectType !=
                    '分页' &&
                  this.homePageList[this.activeIndex].template.objectType !=
                    '组合'
                "
              >
                <span style="width: 50px; margin-left: 20px">列数:</span>
                <el-select
                  v-model="homePageList[activeIndex].colAmount"
                  placeholder=""
                  @change="changeCol"
                >
                  <el-option
                    v-for="item in colOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="label-show"
                style="margin-top: 20px"
                v-if="
                  this.homePageList[this.activeIndex].template &&
                  this.homePageList[this.activeIndex].template.objectType !=
                    '分页' &&
                  this.homePageList[this.activeIndex].template.objectType !=
                    '组合'
                "
              >
                <span style="width: 50px; margin-left: 20px">行数:</span>
                <el-select
                  v-model="homePageList[activeIndex].rowAmount"
                  placeholder=""
                  @change="changeRow"
                >
                  <el-option
                    v-for="item in rowOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="line"></div>
              <div
                class="operation-2"
                v-if="
                  this.homePageList[this.activeIndex].template &&
                  this.homePageList[this.activeIndex].template.objectType !=
                    '分页' &&
                  this.homePageList[this.activeIndex].template.objectType !=
                    '组合'
                "
              >
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="label-show chunk"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="index"
                    @click="openaddFormVisible(1, index)"
                  >
                    <span style="width: 50px">{{ activeObjectType }}:</span>
                    <span style="color: #4d94ff; width: 260px">{{
                      item.title
                    }}</span>
                    <i
                      class="el-icon-delete chunk-delete"
                      v-if="homePageList[activeIndex].sortType == 3"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                </draggable>

                <div
                  class="operation-2-button"
                  v-if="homePageList[activeIndex].sortType == 3"
                >
                  <el-button icon="el-icon-plus" style="width: 100%"
                    >添加课程</el-button
                  >
                </div>
              </div>
            </div>

            <div v-if="activeType == 3">
              <div class="operation-name">自定义</div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">标题:</span>
                <el-select
                  v-model="homePageList[activeIndex].title"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in diyTemplateOption"
                    :key="item.remark"
                    :label="item.name"
                    :value="item.remark"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <!-- 广告 -->
            <div v-if="activeType == 4">
              <div class="operation-name">广告</div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">模板:</span>
                <el-select
                  v-model="homePageList[activeIndex].templateId"
                  placeholder="选择模板"
                  @change="changeTemplate"
                >
                  <el-option
                    v-for="item in templateOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">标题:</span>
                <el-input
                  size="mini"
                  style="width: 200px"
                  placeholder="选填"
                  v-if="homePageList[activeIndex]"
                  v-model="homePageList[activeIndex].title"
                  clearable
                ></el-input>
              </div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">更多:</span>
                <el-input
                  size="mini"
                  style="width: 200px"
                  placeholder="选填"
                  v-if="homePageList[activeIndex]"
                  v-model="homePageList[activeIndex].moreUrl"
                  clearable
                ></el-input>
              </div>

              <div class="operation-1">
                <div class="operation-1-text">添加内容</div>
                <div class="operation-1-text1">
                  <!-- 最多添加12个轮播图，拖动选中的轮播图可对其排序，建议尺寸750*260像素 -->
                </div>
              </div>
              <div
                class="operation-2"
                v-if="
                  homePageList[activeIndex] &&
                  homePageList[activeIndex].schoolPageItemList
                "
              >
                <draggable
                  v-model="homePageList[activeIndex].schoolPageItemList"
                  @update="datadragEnd"
                  :options="{ animation: 500 }"
                >
                  <div
                    class="operation-2-list"
                    v-for="(item, index) in homePageList[activeIndex]
                      .schoolPageItemList"
                    :key="item.id"
                  >
                    <div class="list-img">
                      <el-upload
                        class="crm-upload"
                        :action="fileObj.url"
                        :before-upload="lbtbeforeUpload"
                        :on-success="lbtSuccessUpdate"
                        :headers="reqData"
                        :show-file-list="false"
                      >
                        <img
                          class="list-img"
                          :src="item.picture"
                          @click="updateImg(index)"
                          alt
                        />
                        <div class="list-img-uptext" @click="updateImg(index)">
                          修改
                        </div>
                      </el-upload>
                    </div>
                    <div class="list-msg">
                      <div class="list-msg-item">
                        <span style="width: 50px">链接</span>
                        <el-input
                          style="width: 140px"
                          @input="changeInput(index)"
                          size="mini"
                          v-if="item.type == 2"
                          v-model="item.title"
                          clearable
                        ></el-input>
                        <el-input
                          style="width: 140px"
                          size="mini"
                          @input="changeInput(index)"
                          v-else-if="item.linkUrl"
                          v-model="item.linkUrl"
                          clearable
                        ></el-input>
                        <el-dropdown trigger="click" @command="handleCommand">
                          <span
                            class="el-dropdown-link"
                            style="
                              color: rgb(77, 148, 255);
                              cursor: pointer;
                              margin-left: 10px;
                            "
                          >
                            {{
                              item.linkUrl || item.type == 2
                                ? "修改"
                                : "选择跳转到的页面"
                            }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                          </span>
                          <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="4 + '-' + index"
                              >外部链接</el-dropdown-item
                            >
                          </el-dropdown-menu>
                        </el-dropdown>
                      </div>
                    </div>
                    <i
                      class="el-icon-delete operation-delete"
                      title="删除"
                      @click="deleteItem(index)"
                    ></i>
                  </div>
                </draggable>
              </div>
              <div class="operation-2-button">
                <el-upload
                  style="width: 100%"
                  class="crm-upload"
                  :action="fileObj.url"
                  :before-upload="lbtbeforeUpload"
                  :on-success="lbtSuccess"
                  :headers="reqData"
                  multiple
                  :show-file-list="false"
                >
                  <el-button icon="el-icon-plus" style="width: 380px"
                    >添加广告</el-button
                  >
                </el-upload>
              </div>
            </div>
            <!-- 广告 -->
            <div v-if="activeType == 5">
              <div class="operation-name">悬浮窗</div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">标题:</span>
                <el-input
                  size="mini"
                  style="width: 200px"
                  placeholder="选填"
                  v-if="homePageList[activeIndex]"
                  v-model="homePageList[activeIndex].title"
                  clearable
                ></el-input>
              </div>
              <div class="label-show" style="margin-top: 20px">
                <span style="width: 50px; margin-left: 20px">模板:</span>
                <el-select
                  v-model="homePageList[activeIndex].templateId"
                  placeholder="选择模板"
                  @change="changeTemplate"
                >
                  <el-option
                    v-for="item in templateOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="自定义链接"
      :visible.sync="addFormVisible3"
      width="40%"
      left
    >
      <el-form label-width="80px">
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="链接地址">
              <el-input style="width: 100%" v-model="linkUrl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog3">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="'添加'"
      :visible.sync="addFormVisible"
      width="60%"
      left
      :close-on-click-modal="false"
    >
      <el-form :label-width="formLabelWidth">
        <div v-if="activeObjectType == '商品'">
          <el-row :span="24">
            <el-col :sm="5" :md="5" :lg="5">
              <el-form-item label="所属分类" label-width="80px" prop="pid">
                <el-cascader
                  v-model="searchForm.subjectIds"
                  :show-all-levels="false"
                  ref="tree"
                  collapse-tags
                  :options="subjectTreeList"
                  :props="subjectTreeProps"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :sm="5" :md="5" :lg="5">
              <el-form-item
                label="是否限购"
                label-width="80px"
                prop="flashSaleType"
              >
                <el-select
                  v-model="searchForm.flashSaleType"
                  placeholder="请选择"
                  clearable
                >
                  <el-option value="">全部</el-option>
                  <el-option :label="'是'" :value="'1'"></el-option>
                  <el-option :label="'否'" :value="'-1'"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="8" :md="8" :lg="8">
              <el-form-item label="商品名称">
                <el-input v-model="searchForm.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                :data="tableList"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                @current-change="selectionChange"
                border
                v-loading="loading1"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
              >
                <el-table-column prop="name" show-overflow-tooltip label="商品">
                  <template slot-scope="row">
                    <el-row>
                      <el-col :span="8">
                        <span>
                          <img
                            style="margin-right: 10px"
                            width="100%"
                            height="44px"
                            :src="
                              row.row.logo
                                ? row.row.logo
                                : '../../../static/image/noImg.png'
                            "
                          />
                        </span>
                      </el-col>
                      <el-col :span="16">
                        <span
                          style="color: rgb(77, 148, 255); margin-left: 10px"
                          >{{ row.row.name }}</span
                        >
                        <span style="display: block; margin-left: 10px">
                          <span style="color: red">￥{{ row.row.price }}</span>
                          <span
                            style="
                              text-decoration: line-through;
                              color: rgb(162, 170, 188);
                            "
                            >￥{{ row.row.originalPrice }}</span
                          >
                        </span>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="200"
                  prop="agentPrice"
                  label="售价"
                >
                  <template slot-scope="row">
                    <span style="display: block">
                      <span style="color: red">￥{{ row.row.price }}</span>
                      <span
                        style="
                          text-decoration: line-through;
                          color: rgb(162, 170, 188);
                        "
                        >￥{{ row.row.originalPrice }}</span
                      >
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  prop="validDay"
                  width="100"
                  label="有效期"
                >
                  <template slot-scope="row">{{
                    row.row.validDay ? row.row.validDay + "天" : "不限"
                  }}</template>
                </el-table-column>
                <el-table-column
                  show-overflow-tooltip
                  width="200"
                  prop="subjectCourseName"
                  label="所属科目"
                ></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
        <div v-else-if="activeObjectType == '政策'">
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                :data="tableList"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                @current-change="selectionChange"
                border
                v-loading="loading1"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
              >
                <el-table-column prop="poster" label="图片" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.poster
                          ? row.row.poster
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="city"
                  label="城市"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="title"
                  label="标题"
                  width="250"
                ></el-table-column>
                <el-table-column
                  prop="content"
                  label="内容"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
        <div v-else-if="activeObjectType == '资讯'">
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                :data="tableList"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                @current-change="selectionChange"
                border
                v-loading="loading1"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
              >
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="poster" label="主海报" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.poster
                          ? row.row.poster
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="poster" label="主海报" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.poster
                          ? row.row.poster
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="avatar" label="头像" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.avatar
                          ? row.row.avatar
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column label="内容">
                  <template slot-scope="row">
                    <div class="news-content" v-html="row.row.content"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="summary" label="简介"></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
        <div v-else-if="activeObjectType == '机构'">
          <el-row :span="24">
            <el-col :sm="9" :md="9" :lg="9">
              <el-form-item label="所属分类" label-width="80px" prop="pid">
                <el-cascader
                  v-model="searchForm.subjectIds"
                  :show-all-levels="false"
                  ref="tree"
                  collapse-tags
                  :options="schoolTreeList"
                  :props="subjectTreeProps"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :sm="5" :md="5" :lg="5" style="margin-left: 10px">
              <el-button type="primary" @click="getList()">查询</el-button>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-table
                :data="tableList"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                @current-change="selectionChange"
                border
                v-loading="loading1"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
              >
                <el-table-column prop="img" label="图片" width="120">
                  <template slot-scope="row">
                    <img
                      style="margin-right: 10px"
                      width="100%"
                      height="44px"
                      :src="
                        row.row.img
                          ? row.row.img
                          : '../../../static/image/noImg.png'
                      "
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="dictionaryName"
                  label="城市"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  label="标题"
                  width="250"
                ></el-table-column>
                <el-table-column
                  prop="rate"
                  label="评分"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, prev, pager, next"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>

    <div class="previewBox" v-show="previewModal">
      <preview-temp ref="preiveTempModal"></preview-temp>
    </div>
  </div>
</template>

<script>
// import cityTemplate from "./diyTemplate/cityTemplate";
// import moreCityTemplate from "./diyTemplate/moreCityTemplate";
import previewTemp from "./components/previewTemp";
import courseTypeTemplate from "./diyTemplate/courseTypeTemplate";
import imageTemplate from "./diyTemplate/imageTemplate";
import limitPurchase from "./diyTemplate/limitPurchase";
import popularRecommendation from './diyTemplate/popularRecommendation'
import liveDisplay from './diyTemplate/liveDisplay'
import teacher from './diyTemplate/teacher'
import Header from "./diyTemplate/Header";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import mubanTemplate from "./template/mubanTemplate.vue";
import carousel from "./template/carousel";
import templateOne from "../onlineTemplate/template/index";
import editPanel from "../onlineTemplate/template/editPanel";
export default {
  components: {
    previewTemp,
    draggable,
    limitPurchase,
    mubanTemplate,
    carousel,
    templateOne,
    editPanel,
    Header,
    imageTemplate,
    courseTypeTemplate,
    popularRecommendation,
    liveDisplay,
    teacher
    // cityTemplate,
    // moreCityTemplate,
  },

  data() {
    return {
      hoverObj: {},
      previewModal: false,
      goodsOptions: [],
      diyTemplateOption: [],
      schoolTreeList: [],
      activeObjectType: "",
      addFormVisibleSpkc: false,
      linkUrl: "",
      addFormVisible3: false,
      searchForm: {
        sell: 1,
        name: "",
        subjectIds: [],
      },
      schoolPageMenuId: "",
      pageMenuList: [],
      tempOptions: [],
      colOption: [
        { label: "一行1个", value: "1" },
        { label: "一行2个", value: "2" },
        { label: "一行3个", value: "3" },
        { label: "一行4个", value: "4" },
        { label: "一行5个", value: "5" },
        { label: "一行6个", value: "6" },
        { label: "一行7个", value: "7" },
        { label: "一行8个", value: "8" },
      ],
      rowOption: [
        { label: "1行", value: "1" },
        { label: "2行", value: "2" },
        { label: "3行", value: "3" },
        { label: "4行", value: "4" },
      ],
      isShowObjectId: false,
      templateOptions: [],
      tempOptions: [],
      choosedTemplate: "",
      state: 1,
      homePageList: [],
      // activeModuleId:'',
      activeIndex: "",
      activeType: "",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      itemIndex: "",
      tableList: [],
      page: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      arrsSelect: [],
      loading1: false,
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
        multiple: true,
      },
      addFormVisible: false,
      checkList: [],
      linkUrl: "",
      formLabelWidth: "80px",
      addFormVisibleSpkc: false,
      addGoodsFormType: 1,
      addopenaddInformationFormVisible: false,
      informationSearchForm: {
        title: "",
      },
      informationPage: {
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      informationList: [],
      informationCheckList: [],
      mainUrl: "/",
      options: [
        {
          value: "/",
          label: "首页",
        },
        {
          value: "/allCourse",
          label: "全部课程",
        },
      ],
    };
  },
  watch: {
    addFormVisible(val) {
      if (!val) {
        this.searchForm.subjectIds = [];
        this.searchForm.name = "";
      }
    },
  },

  methods: {
    // ------------------------------获取模板list
    getSchoolPageTemplateList() {
      this.api.schoolPageTemplate.getSchoolPageTemplateList().then((res) => {
        this.tempOptions = res.data;
      });
    },
    getGoodsOptions(val) {
      let parentId = "1415194153601642498";
      this.api.dictionary
        .getDictionaryListByParentId({
          parentId,
        })
        .then((res) => {
          this.goodsOptions = res.data;
        });
    },
    // 轮播图------------------------------------------------------------
    hoverStart(index, _index) {
      if (this.homePageList[index].template.template !== null) {
        this.homePageList[index].schoolPageItemList[_index].dynamicObj =
          this.homePageList[index].template.template;
      }
    },
    hoverEnd(index, _index) {
      if (this.homePageList[index].template.template !== null) {
        this.homePageList[index].schoolPageItemList[_index].dynamicObj =
          this.homePageList[index].template;
      }
    },
    lbtbeforeUpload(file) {
      this.loading = true;
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        this.loading = false;
      }
      return isJPG && isLt2M;
    },
    lbtSuccessUpdate(res, file, fileList, val) {
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].picture = res.data;

      this.itemIndex = "";
    },
    lbtSuccess(res, file, fileList, val) {
      if (!this.homePageList[this.activeIndex].schoolPageItemList) {
        this.homePageList[this.activeIndex].schoolPageItemList = [];
      }
      let type = 1;
      if (this.activeType == 4) {
        type = 7;
      }
      this.homePageList[this.activeIndex].schoolPageItemList.push({
        picture: res.data,
        title: "",
        type,
        sort: this.homePageList[this.activeIndex].schoolPageItemList.length,
        dynamicObj: this.homePageList[this.activeIndex].template,
      });
    },
    updateImg(index) {
      this.itemIndex = index;
    },
    deleteItem(index) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.homePageList[this.activeIndex].schoolPageItemList.splice(
            index,
            1
          );
        })
        .catch(() => {});
    },
    changeInput(index) {
      this.homePageList[this.activeIndex].schoolPageItemList[index].linkUrl =
        "";
      this.homePageList[this.activeIndex].schoolPageItemList[index].title = "";
      this.homePageList[this.activeIndex].schoolPageItemList[index].type = "";
      this.$forceUpdate();
    },
    handleCommand(command) {
      let arr = command.split("-");
      let type = arr[0];
      this.itemIndex = arr[1];
      if (type == 1) {
      } else if (type == 2) {
        this.openaddFormVisible(1);
      } else if (type == 4) {
        this.addFormVisible3 = true;
      }
    },
    closeDialog3() {
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].linkUrl = this.linkUrl;
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].type = 1;
      this.linkUrl = "";
      this.addFormVisible3 = false;
    },
    openaddFormVisible(type, index) {
      this.itemIndex = index;
      if (type == 1) {
        this.addGoodsFormType = 1;
        this.addFormVisible = true;
      } else if (type == 2) {
        this.addGoodsFormType = 2;
        this.addFormVisible = true;
      }
      this.getList();
    },
    getSubjectTreeList() {
      let arr = [];
      this.api.getSubjectCourseAllTree({}).then((_res) => {
        this.subjectTreeList = this.changeDisable(_res.data);
      });
    },
    changeDisable(arr) {
      if (arr && arr.length > 0) {
        arr.forEach((item) => {
          item.disabled = false;
          this.changeDisable(item.children);
        });
        return arr;
      } else {
        return [];
      }
    },
    getList() {
      this.loading1 = true;
      let arr = [];
      if (this.searchForm.subjectIds.length > 0) {
        this.searchForm.subjectIds.forEach((item) => {
          arr.push(item.reverse()[0]);
        });
      }
      let obj = {
        pageSize: this.page.pageSize,
        pageNumber: this.page.pageNumber,
        sortName: this.page.sortName,
        sortOrder: this.page.sortOrder,
        agentId: this.loginData.agentId,
        flashSaleType: this.searchForm.flashSaleType,
        name: this.searchForm.name,
        subjectIds: arr,
      };

      let requestUrl = "pageList";
      if (this.activeObjectType == "政策") {
        requestUrl = "pageListPolicy";
      } else if (this.activeObjectType == "资讯") {
        requestUrl = "pageListInformation";
      } else if (this.activeObjectType == "机构") {
        requestUrl = "pageListCampus";
      } else if (this.activeObjectType == "广告") {
        return;
      }

      this.api.goodsInfo[requestUrl](obj)
        .then((result) => {
          this.loading1 = false;
          this.tableList = result.data.records;
          this.page.total = result.data.total;
          this.arrsSelect = [];
        })

        .catch((error) => {
          console.log(error);
        });
    },
    closeDialog() {
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].relationId = this.checkList.id;
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].title =
        this.activeObjectType != "商品" && this.activeObjectType != "机构"
          ? this.checkList.title
          : this.checkList.name;
      this.homePageList[this.activeIndex].schoolPageItemList[
        this.itemIndex
      ].schoolPageInfo = {
        ...this.checkList,
      };
      this.itemIndex = "";
      this.addFormVisible = false;
      this.addFormVisibleSpkc = false;
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.getList();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getList();
    },
    selectionChange(val) {
      this.checkList = val;
    },
    //------------------------------------------------------------轮播图
    // 自定义组件------------------------------------------------------------
    getTemplateList(name) {
      let obj = {};
      let arr = [];
      let nameList = ["轮播图", "广告", "悬浮窗"];
      if (nameList.some((item) => item == name)) {
        this.goodsOptions.forEach((item) => {
          if (item.name == name) {
            obj.objectId = item.id;
          }
        });
      } else {
        this.goodsOptions.forEach((item) => {
          if (nameList.every((Item) => item.name != Item)) {
            arr.push(item.id);
          }
        });
        obj.objectIds = arr;
      }
      this.api.template.getTemplateList(obj).then((res) => {
        this.templateOptions = res.data;
      });
    },
    getDiyTemplateList() {
      this.api.dictionary
        .getDictionaryListByParentId({ parentId: "1420210886402027521" })
        .then((res) => {
          this.diyTemplateOption = res.data;
        });
    },
    changeCol(val) {
      let arr = [];
      let amount = this.homePageList[this.activeIndex].rowAmount * val;
      this.homePageList[this.activeIndex].mubanWidth = 1200 / val;
      this.changeGoodsList();
    },
    changeRow(val) {
      let arr = [];
      let amount = this.homePageList[this.activeIndex].colAmount * val;
      this.changeGoodsList();
    },
    changeGoodsList() {
      if (this.activeObjectType == "组合" || this.activeObjectType == "分页") {
        this.homePageList[this.activeIndex].colAmount = 1;
        this.homePageList[this.activeIndex].rowAmount = 1;
      }
      let capacity =
        this.homePageList[this.activeIndex].colAmount *
        this.homePageList[this.activeIndex].rowAmount;
      let params = {
        pageNumber: 1,
        pageSize: capacity,
      };

      let schoolPageItemList = [];
      let requestUrl = "pageList";
      if (this.activeObjectType == "政策") {
        requestUrl = "pageListPolicy";
      } else if (this.activeObjectType == "资讯") {
        requestUrl = "pageListInformation";
      } else if (this.activeObjectType == "机构") {
        requestUrl = "pageListCampus";
      }
      let type;
      if (this.activeObjectType == "商品") {
        type = 2;
      } else if (this.activeObjectType == "资讯") {
        type = 3;
      } else if (this.activeObjectType == "政策") {
        type = 4;
      } else if (this.activeObjectType == "机构") {
        type = 6;
      } else if (this.activeObjectType == "广告") {
        type = 7;
      } else {
        type = 5;
      }
      this.api.goodsInfo[requestUrl](params)
        .then((result) => {
          if (result.success) {
            let data = result.data.records;
            if (data) {
              data.forEach((item) => {
                schoolPageItemList.push({
                  relationId: item.id,
                  title:
                    this.activeObjectType != "商品" &&
                    this.activeObjectType != "机构"
                      ? item.title
                      : item.name,
                  type,
                  sort: 0,
                  dynamicObj: this.homePageList[this.activeIndex].template,
                  schoolPageInfo: {
                    ...item,
                  },
                });
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.homePageList[this.activeIndex].schoolPageItemList =
        schoolPageItemList;
      this.homePageList[this.activeIndex].capacity = capacity;
    },
    changeTemplate() {
      this.api.template
        .getTemplate(this.homePageList[this.activeIndex].templateId)
        .then((res) => {
          this.homePageList[this.activeIndex].templateId =
            this.homePageList[this.activeIndex].templateId;
          this.homePageList[this.activeIndex].template = res.data;
          if (this.homePageList[this.activeIndex].type == 5) {
            this.homePageList[this.activeIndex].schoolPageItemList = [
              {
                type: 5,
                dynamicObj: res.data,
              },
            ];
          } else {
            this.activeObjectType = res.data.objectType;
            this.changeGoodsList();
            this.homePageList[this.activeIndex].schoolPageItemList.forEach(
              (item) => {
                item.dynamicObj = res.data;
                if (res.data.objectType == "商品") {
                  item.type = 2;
                } else if (res.data.objectType == "资讯") {
                  item.type = 3;
                } else if (res.data.objectType == "政策") {
                  item.type = 4;
                } else if (res.data.objectType == "机构") {
                  item.type = 6;
                } else if (res.data.objectType == "广告") {
                  item.type = 7;
                } else {
                  item.type = 5;
                }
              }
            );
          }
        });
    },
    changeLBTemplate() {
      this.api.template
        .getTemplate(this.homePageList[this.activeIndex].templateId)
        .then((res) => {
          this.homePageList[this.activeIndex].templateId =
            this.homePageList[this.activeIndex].templateId;
          this.homePageList[this.activeIndex].template = res.data;
          this.$forceUpdate();
        });
    },
    objectAssign(obj) {
      let jsonObj = JSON.parse(obj.styleJson);
      return Object.assign({}, obj, jsonObj);
    },
    // ------------------------------------------------------------自定义组件
    getSchoolPageMenuListByUrl(url) {
      this.api.schoolPage
        .getSchoolPageMenuListByUrl({ url: url })
        .then((res) => {
          this.pageMenuList = res.data;
          if (this.pageMenuList.length > 0) {
            this.pageMenuList.forEach((item) => {
              if (item.linkUrl == url) {
                this.schoolPageMenuId = item.id;
                this.getHomePageListByTemplateId();
              }
            });
          } else {
            this.schoolPageMenuId = "";
          }
        });
    },

    getTempDictionary(callback) {
      this.api.dictionary
        .getTempDictionaryData()
        .then((result) => {
          this.tempOptions = result.data;
          result.data.forEach((v, k) => {
            if (v.defaultTheme) this.choosedTemplate = v.id;
          });

          callback && callback();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    hoverModule(pageIndex) {
      this.$set(this.homePageList[pageIndex], "moduleHover", true);
    },
    leaveModule(pageIndex) {
      if (pageIndex != this.activeIndex) {
        this.$set(this.homePageList[pageIndex], "moduleHover", false);
      }
    },
    activeModule(pageIndex) {
      if (this.homePageList[pageIndex].template) {
        this.getTemplateList(this.homePageList[pageIndex].template.objectType);
      }

      for (let item of this.homePageList) {
        this.$set(item, "moduleHover", false);
      }
      let homePageListItem = this.homePageList[pageIndex];
      this.activeIndex = pageIndex;
      this.activeType = homePageListItem.type;
      if (this.homePageList[pageIndex].type == 2) {
        if (this.homePageList[pageIndex].schoolPageItemList.length != 0) {
          this.homePageList[pageIndex].schoolPageItemList.forEach((item) => {
            if (item.type == 2) {
              this.activeObjectType = "商品";
            } else if (item.type == 3) {
              this.activeObjectType = "资讯";
            } else if (item.type == 4) {
              this.activeObjectType = "政策";
            } else if (item.type == 6) {
              this.activeObjectType = "机构";
            } else if (item.type == 7) {
              this.activeObjectType = "广告";
            }
          });
        }
      }
      this.$set(this.homePageList[pageIndex], "moduleHover", true);
    },
    deleteModule(pageIndex) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.homePageList.splice(pageIndex, 1);
          this.activeIndex = "";
          this.activeType = "";
        })
        .catch(() => {});
    },
    getHomePageListByTemplateId() {
      this.api.schoolPage
        .getHomePageListByTemplateId({
          schoolPageTemplateId: this.schoolPageTemplateId,
          schoolPageMenuId: this.schoolPageMenuId,
        })
        .then((result) => {
          this.loading = false;
          if (result.success) {
            result.data.forEach((item) => {
              if (item.type == 2 || item.type == 5 || item.type == 4) {
                if (item.schoolPageItemList) {
                  item.schoolPageItemList.forEach((_item) => {
                    _item.dynamicObj = item.template;
                  });
                  item.mubanWidth = 1200 / item.colAmount;
                }
              }
            });
            this.$set(this, "homePageList", result.data);
            this.homePageList = result.data;
            this.activeIndex = 0;
          } else {
            this.homePageList = [];
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    datadragEnd(evt) {
      evt.preventDefault();
    },
    datadragEndContent(evt) {
      this.activeModule(evt.newIndex);
      evt.preventDefault();
    },
    addModule(type, title) {
      this.getTemplateList(title);
      if (type == 3) {
        title = "";
      }
      if (!this.homePageList) {
        this.homePageList = [];
      }
      let sortType = 1;
      let capacity = 1;
      let schoolPageItemList = [];
      this.homePageList.push({
        moduleHover: false,
        title: title,
        type: type,
        sort: this.homePageList.length,
        schoolPageItemList: [],
        sortType: sortType,
        templateId: undefined,
        capacity: capacity,
        template: undefined,
        colAmount: 1,
        rowAmount: 1,
        mubanWidth: 580,
      });
      this.activeIndex = this.homePageList.length - 1;
      this.$nextTick(function () {
        var container = this.$el.querySelector("#pcCenterMain");
        container.scrollTop = container.scrollHeight;
      });
    },
    updataSchoolPage() {
      this.$prompt("请输入密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value == "123456") {
            this.api.schoolPage
              .updateAgentHomeSchoolPage({
                agentId: "621995219419136",
                schoolPageMenuId: this.schoolPageMenuId,
              })
              .then((res) => {
                this.$message.success(res.message);
              });
          } else {
            this.$message.error("密码错误");
          }
        })
        .catch(() => {});
    },
    saveSchoolPage() {
      this.homePageList.forEach((item) => {
        item.schoolPageMenuId = this.schoolPageMenuId;
      });
      let obj = {
        id: this.schoolPageTemplateId,
        schoolPageList: this.homePageList,
      };
      this.api.schoolPage
        .updateHomeSchoolPageByTemplateId(obj)
        .then((result) => {
          if (result.success) {
            this.activeIndex = "";
            this.activeType = "";
            this.getHomePageListByTemplateId();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    previewTemp(item) {
      this.hoverObj = item;
      this.previewModal = true;
      this.$refs.preiveTempModal.initEveryTIme(item.id, item.type);
    },
    hidePreviewTemp(item) {
      this.previewModal = false;
    },
  },
  created() {
    this.schoolPageTemplateId = this.$route.query.id;
    // this.getSchoolPageTemplateList();
    this.getTempDictionary(() => {});
    this.getDiyTemplateList();
    this.getSubjectTreeList();
    console.log("asddddddddddddddddddddddddddddddddddddddddddd");
    this.getGoodsOptions();
    this.getSchoolPageMenuListByUrl(this.mainUrl);
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    },
  },
};
</script>
<style lang="less" scoped>
.news-content {
  height: 50px;
  img {
    display: none;
  }
}
.previewBox {
  border-radius: 2px;
  margin: 15vh auto 0 !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
  z-index: 9999;
}
.pcSetting {
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  .pcSettingMain {
    display: flex;
    min-height: 700px;
    justify-content: space-between;
    // overflow-x: scroll;
  }
  .pcLeft {
    width: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #eee;
  }
  .pcLeftItem {
    width: 60px;
    height: 60px;
    margin-top: 15px;
    padding: 2px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .pcLeftItem:hover {
    background: #266ef6;
    color: #fff;
  }
  .pcRight {
    width: 400px;
    border-left: 1px solid #eee;
    padding: 10px;
    margin-top: 30px;
  }
  .pcRight-title {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
  }
  .pcCenter {
    overflow-x: scroll;
    overflow-y: auto;
    background: #f6f7f9;
    height: 95vh;
    position: relative;
    // width: 910px;
  }

  // 中间区域css
  .pageContainer {
    padding-bottom: 20px;
    color: #455a64;
    height: 700px;
    width: 1500px;
  }
  .mainContent {
    width: 1204px;
    margin: 0 auto;
  }
  .el-menu {
    border-bottom: none !important;
  }
  .el-menu-item {
    padding: 0;
    margin: 0 20px !important;
    font-size: 16px;
  }
  .flex {
    display: -webkit-flex; /* Safari */
    display: flex;
  }
  .font1Line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .font2Line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .font6Line {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }
  .moduleMain {
    margin-top: 20px;
    cursor: pointer;
    position: relative;
    border: 2px solid #f6f7f9;
  }
  .moduleMain.active {
    border: 2px solid #266ef6;
  }
  .moduleMain:hover {
    border: 2px dashed #266ef6;
  }
  .moudleTitle {
    font-size: 24px;
    padding: 10px 0;
  }
  .moudleGoodsMain {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .moudleNewsMain {
    width: 700px;
  }
  .moudleNewsMain img {
    width: 350px;
    height: 200px;
    border-radius: 5px;
  }
  .moudleGoodsItem {
    width: 166px;
    height: 180px;
    margin-top: 10px;
    border-radius: 5px;
    background-color: #fff;
    margin-left: 5px;
    // cursor: pointer;
  }
  .moudleGoodsItem img {
    height: 100px;
    width: 166px;
    border-radius: 5px;
  }
  .moudleGoodsName {
    padding: 5px 10px 0 10px;
    // font-size: 16px;
    height: 35px;
  }
  .moudleGoodsEnd {
    justify-content: space-between;
    padding: 5px 10px 0 10px;
    align-items: center;
  }
  .moudleGoodsSell {
    color: #a2aabc;
    font-size: 12px;
  }
  .moudleGoodsPrice {
    color: #fc5e5e;
  }
  .moudleGoodsPrice span {
    font-size: 24px;
  }
  .newsTitleMain {
    margin-left: 40px;
    font-size: 16px;
    line-height: 20px;
  }
  .parentLinkMain {
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
  }
  .parentLinkItem {
    flex-wrap: wrap;
  }
  .parentLinkItem div {
    margin: 5px 5px 0 0;
    color: #a2aabc;
    font-size: 12px;
  }
  //结束
  .icon-shanchu {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #79797a;
    color: #fff;
    padding: 4px;
    z-index: 999;
  }
  .pcRightTips {
    color: #a2aabc;
    font-size: 13px;
  }
  .lunboItem {
    width: 420px;
    height: 80px;
  }
  .operation {
    // position: fixed;
    // top: 123px;
    // right: 20px;
    width: 380px;
    height: calc(100% - 0px);
    // background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(238, 238, 238, 1);
    font-family: "微软雅黑";
    font-weight: 400;
    font-style: normal;
    background-color: #fafafa;
    .operation-2 {
      padding: 20px;
      .operation-2-button {
      }
      .operation-2-list:hover {
        .operation-delete {
          display: inline-block;
        }
      }
      .operation-2-list {
        position: relative;
        margin-bottom: 10px;
        background-color: rgba(255, 255, 255, 1);
        border-width: 1px;
        border-style: solid;
        padding: 10px;
        border-color: rgba(238, 238, 238, 1);
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        .operation-delete {
          position: absolute;
          bottom: 6px;
          right: 10px;
          z-index: 100;
          cursor: pointer;
          font-size: 14px;
          color: rgba(255, 85, 85, 1);
          display: none;
        }
        .list-msg {
          margin-left: 10px;
          .list-msg-item {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
            }
          }
        }
        .list-img {
          width: 60px;
          height: 60px;
          z-index: 2000;
          position: relative;
          .list-img-uptext {
            z-index: 2000;
            width: 60px;
            height: 20px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: #333;
            opacity: 0.6;
            color: #fff;
            font-size: 14px;
            line-height: 20px;
            text-align: center;
          }
        }
      }
    }
    .operation-1 {
      background-color: rgba(255, 255, 255, 1);
      padding: 20px;
      .operation-1-text {
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        color: #455a64;
        line-height: 14px;
      }
      .operation-1-text1 {
        padding-top: 10px;
        font-family: "微软雅黑";
        font-weight: 400;
        font-style: normal;
        color: #a2aabc;
        line-height: 16px;
      }
    }
    .operation-name {
      background-color: rgba(255, 255, 255, 1);
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      font-weight: 700;
      font-style: normal;
      font-size: 16px;
      color: #455a64;
      text-align: left;
      line-height: 60px;
      padding: 0 0 0 20px;
    }
  }
  .label-show {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .chunk {
    height: 40px;
    line-height: 40px;
    padding: 0px 0px 0px 10px;
    background-color: rgba(255, 255, 255, 1);
    cursor: pointer;
    .chunk-delete {
      font-size: 14px;
      color: rgba(255, 85, 85, 1);
      display: none;
    }
  }
  .chunk:hover {
    .chunk-delete {
      display: inline-block;
    }
  }
  .emptyDiv {
    border: 2px solid #a2aabc;
    color: #a2aabc;
    font-size: 30px;
    text-align: center;
    line-height: 400px;
  }
}
.subTitle {
  font-size: 16px;
  font-weight: bold;
  color: #455a64;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/onlineSchool/pcSetting.vue